/**
 * Angular imports.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

/**
 * Module imports.
 */
import { AppBootstrapModule } from '../app-bootstrap/app-bootstrap.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
// import { PipesModule } from '../pipes/pipes.module';
import { DirectivesModule } from '../directives/directives.module';
// import { MatButtonModule } from '@angular/material/button';
// import { MatCardModule } from '@angular/material/card';
import { MiddleWareRoutingModule } from './middle-ware-routing.module';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { PostingModule } from '../web/posting/posting.module';
import { FeedDetailModalModule } from '../common/feed-detail-modal/feed-detail-modal.module';
// import { ProductSubscribeModule } from '../common/product-subscribe/product-subscribe.module';
import { DatePickerModule } from '../common/calender/datepicker/date-picker.module';
import { WebModalModule } from '../common/web-modal/web-modal.module';
import { StoriesModule } from '../stories/stories.module';

import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';
/**
 * Component imports.
 */
import { MiddleWareComponent } from '../authorised-zone/middle-ware.component';
import { WebCmeVaultAddSkpPointsComponent } from '../web-cme/web-cme-my-vault/web-cme-vault-add-skp-points/web-cme-vault-add-skp-points.component';
import { InternetConnectionModalComponent } from '../common/internet-connection-modal/internet-connection-modal.component';

/**
 * Directive imports.
 */
import { DefaultimageDirective } from '../directives/defaultimage.directive';
import { OnboardingService } from '../dataservices/onboarding/onboarding.service';
import { SamvaadModule } from '../samvaad/samvaad.module';
import { NudgesModule } from '../nudges/nudges.module';

@NgModule({
  imports: [
    MiddleWareRoutingModule,
    // MatCardModule,
    // MatButtonModule,
    AppBootstrapModule,
    InfiniteScrollModule,
    HttpClientModule,
    // PipesModule,
    DirectivesModule,
    CommonModule,
    PostingModule,
    FeedDetailModalModule,
    // ProductSubscribeModule,
    FormsModule,
    AngularMultiSelectModule,
    DatePickerModule,
    WebModalModule,
    SamvaadModule,
    StoriesModule,
    NudgesModule,
    NgxPageScrollCoreModule
  ],
  declarations: [
    DefaultimageDirective,
    MiddleWareComponent,
    WebCmeVaultAddSkpPointsComponent,
    InternetConnectionModalComponent,
  ],
  providers:[

  ]
})
export class MiddleWareModule {
  constructor(public onboardingSer: OnboardingService) {
    this.onboardingSer.setLanguage();
    const script1 = document.createElement('script');
    script1.type = 'text/javascript';
    script1.src = 'assets/js/agora-rtm-sdk/index.js';
    document.head.appendChild(script1);
    const script2 = document.createElement('script');
    script2.type = 'text/javascript';
    script2.src = 'assets/js/hls.js/dist/hls.min.js';
    document.head.appendChild(script2);
    const script3 = document.createElement('script');
    script3.type = 'text/javascript';
    script3.src = 'assets/js/agora-rtc-sdk-ng/AgoraRTC_N-production.js';
    document.head.appendChild(script3);
    const script4 = document.createElement('script');
    script4.type = 'text/javascript';
    script4.src = 'assets/js/pdfjs-dist/build/pdf.worker.min.js';
    document.head.appendChild(script4);
    const script5 = document.createElement('script');
    script5.type = 'text/javascript';
    script5.src = 'assets/js/shaka-player/dist/shaka-player.ui.debug.js';
    document.head.appendChild(script5);
    const script6 = document.createElement('script');
    script6.type = 'text/javascript';
    script6.src = 'assets/js/mux.js';
    document.head.appendChild(script6);
    const script7 = document.createElement('script');
    script7.type = 'text/javascript';
    script7.src = 'assets/js/pdfjs-dist/es5/build/pdf.js';
    document.head.appendChild(script7);
  }
}
